export const loginCredentials = {
  email: 'admin@gmail.com',
  password: '123',
  status: true,
  role: 'user',
  message: 'login successfully',
  token: '1164|ihHvE9J6cn1U3St4Sk6v6JKOdm2ARA87hXYbIdS63831040a',
};
export const loggedInUser = {
  'user-id': 1,
  'full_name': 'Arthur Morgan',
  'first_name': 'Arthur',
  'last_name': 'Morgan',
  type: 'user',
  token: 'somerandomtokenwhichis38characterslong',
  phone: '+190078601',
  dialing_code: '+1',
  email: 'arthurmorgan@rdr2.com',
  'photo_path':
    'https://static.wikia.nocookie.net/villains/images/8/8d/Red_Dead_2_Arthur_Morgan_Promotional_Portrait_1.png',
  location: {
    city: "New York",
    latitude: 40.7091708,
    location: {
      label: "123 William Street, New York, NY, USA",
      value: {
        description: "123 William Street, New York, NY, USA",
        place_id: "ChIJ49W-BhhawokR4KLCF2oTVVo",
        reference: "ChIJ49W-BhhawokR4KLCF2oTVVo",
        structured_formatting: {
          main_text: '123 William Street',
          secondary_text: 'New York, NY, USA'
        },
        terms: [
          { offset: 0, value: '123' },
          { offset: 4, value: 'William Street' },
          { offset: 20, value: 'New York' },
          { offset: 30, value: 'NY' },
          { offset: 34, value: 'USA' }
        ],
        types: ['geocode', 'premise']
      },
    },
    location_name: "123 William St, New York, NY 10038, USA",
    longitude: -74.0069522,
    state: "NY",
    zip_code: "10038"
  }
};

export const userVouchers = [
  {
    id: 1,
    code: 'MC30',
    discount: 30,
    validUntil: '31/08/2025',
    loyaltyPoints: 100,
    isAvailable: true
  },
  {
    id: 2,
    code: 'SAVE25',
    discount: 25,
    validUntil: '31/08/2025',
    loyaltyPoints: 100,
    isAvailable: true
  },
  {
    id: 3,
    code: 'SPECIAL20',
    discount: 20,
    validUntil: '31/08/2025',
    loyaltyPoints: 100,
    isAvailable: true
  }
];

export const restaurantsNearMe = [
  {
    id: 1,
    name: "Steak House",
    rating: 4.5,
    totalRatings: 100,
    distance: "0.1 Km",
    duration: "40 Minutes",
    image: '',
    type: "Restaurant",
    location: {
      latitude: 40.7112753,
      longitude: -74.0079728
    },
    reviews: {
      averageRating: 4.5,
      totalReviews: 200,
      ratingCounts: {
        5: 100,
        4: 25,
        3: 25,
        2: 25,
        1: 25
      },
      reviewList: [
        {
          id: 1,
          userName: "Tom Albert",
          rating: 4.5,
          date: "May, 22 2025",
          comment: "Lorem Ipsum Dolor Sit Amet, Consectetur Adipiscing Elit. Aenean Euismod Bibendum Laoreet. Proin Gravida Dolor Sit Amet Lacus Elit. Accumsan Et Viverra Justo Commodo. Proin Sodales Pulvinar Tempor. Lorem Ipsum Dolor Sit Amet, Consectetur Adipiscing Elit. Lacus Aenean Euismod Bibendum Laoreet. Proin Gravida Dolor Sit Amet Lacus Accumsan"
        },
        {
          id: 2,
          userName: "Sarah Johnson",
          rating: 5,
          date: "May, 20 2025",
          comment: "Exceptional dining experience! The steaks were cooked to perfection and the service was impeccable."
        },
        {
          id: 3,
          userName: "Mike Chen",
          rating: 4,
          date: "May, 18 2025",
          comment: "Great food and atmosphere. Slightly pricey but worth it for special occasions."
        },
        {
          id: 4,
          userName: "Emily Davis",
          rating: 3,
          date: "May, 15 2025",
          comment: "Decent food but had to wait a bit too long. Service could be improved."
        }
      ]
    },
    description: "Premium steakhouse offering the finest cuts of meat and exceptional dining experience",
    cuisine: "American Steakhouse",
    priceRange: "$$$",
    address: "456 Oak Avenue, New York, NY 10002",
    phone: "+1 (555) 123-4567",
    hours: "Mon-Sun: 11:00 AM - 11:00 PM",
    delivery: true,
    pickup: true,
    dineIn: true,
    menu: {
      categories: [
        {
          id: 1,
          name: "Appetizers",
          items: [
            {
              id: 1,
              name: "Bruschetta",
              description: "Toasted bread topped with tomatoes, garlic, and fresh basil",
              price: 8.99,
              image: '',
              available: true,
              popular: true
            },
            {
              id: 2,
              name: "Spinach Artichoke Dip",
              description: "Creamy dip with spinach, artichokes, and melted cheese",
              price: 10.99,
              image: '',
              available: true,
              popular: false
            }
          ]
        },
        {
          id: 2,
          name: "Steaks",
          items: [
            {
              id: 3,
              name: "Ribeye Steak",
              description: "16oz premium ribeye with choice of sides",
              price: 34.99,
              image: '',
              available: true,
              popular: true
            },
            {
              id: 4,
              name: "Filet Mignon",
              description: "8oz tender filet mignon, cooked to perfection",
              price: 42.99,
              image: '',
              available: true,
              popular: true
            },
            {
              id: 5,
              name: "T-Bone Steak",
              description: "20oz T-bone with signature seasoning",
              price: 38.99,
              image: '',
              available: true,
              popular: false
            }
          ]
        },
        {
          id: 3,
          name: "Sides",
          items: [
            {
              id: 6,
              name: "Loaded Baked Potato",
              description: "Baked potato with butter, sour cream, and chives",
              price: 6.99,
              image: '',
              available: true,
              popular: true
            },
            {
              id: 7,
              name: "Grilled Asparagus",
              description: "Fresh asparagus grilled with olive oil and sea salt",
              price: 5.99,
              image: '',
              available: true,
              popular: false
            }
          ]
        },
        {
          id: 4,
          name: "Desserts",
          items: [
            {
              id: 8,
              name: "Chocolate Lava Cake",
              description: "Warm chocolate cake with molten center",
              price: 9.99,
              image: '',
              available: true,
              popular: true
            }
          ]
        }
      ]
    }
  },
  {
    id: 2,
    name: "Liberty",
    rating: 4.5,
    totalRatings: 100,
    distance: "1.5 Km",
    duration: "40 Minutes",
    image: '',
    type: "Restaurant",
    location: {
      latitude: 40.7112753,
      longitude: -74.0079728
    },
    description: "Modern American cuisine with a focus on fresh, local ingredients",
    cuisine: "American Contemporary",
    priceRange: "$$",
    address: "456 Oak Avenue, New York, NY 10002",
    phone: "+1 (555) 234-5678",
    hours: "Mon-Sun: 10:00 AM - 10:00 PM",
    delivery: true,
    pickup: true,
    dineIn: true,
    menu: {
      categories: [
        {
          id: 1,
          name: "Starters",
          items: [
            {
              id: 1,
              name: "Truffle Fries",
              description: "Crispy fries with truffle oil and parmesan",
              price: 7.99,
              image: '',
              available: true,
              popular: true
            }
          ]
        },
        {
          id: 2,
          name: "Main Courses",
          items: [
            {
              id: 2,
              name: "Grilled Salmon",
              description: "Fresh salmon with seasonal vegetables",
              price: 24.99,
              image: '',
              available: true,
              popular: true
            }
          ]
        }
      ]
    }
  },
  {
    id: 3,
    name: "Angus Cafe",
    rating: 4.5,
    totalRatings: 100,
    distance: "1.5 Km",
    duration: "40 Minutes",
    image: '',
    type: "Restaurant",
    location: {
      latitude: 40.7137753,
      longitude: -74.0049728
    }
  },
  {
    id: 4,
    name: "Taco Truck",
    rating: 4.7,
    totalRatings: 85,
    distance: "0.8 Km",
    duration: "25 Minutes",
    image: '',
    type: "Food Truck",
    location: {
      latitude: 40.7147753,
      longitude: -74.0039728
    }
  },
  {
    id: 5,
    name: "Burger Express",
    rating: 4.6,
    totalRatings: 92,
    distance: "1.2 Km",
    duration: "35 Minutes",
    image: '',
    type: "Food Truck",
    location: {
      latitude: 40.7117753,
      longitude: -74.0089728
    }
  }
];

export const takeAwayLogs = {
  data: [
    {
      id: '12345',
      orderDate: '2024-03-15',
      orderTime: '04:20 PM',
      amount: '600.00',
      status: 'pending',
      items: [
        {
          id: '1',
          name: 'Spicy Chicken Burrito',
          image: '',
          price: '200.00',
          quantity: 1,
          total: '200.00'
        },
        {
          id: '2',
          name: 'Mexican Taco Platter',
          image: '',
          price: '200.00',
          quantity: 1,
          total: '200.00'
        },
        {
          id: '3',
          name: 'Guacamole & Chips',
          image: '',
          price: '200.00',
          quantity: 1,
          total: '200.00'
        }
      ],
      summary: {
        subTotal: '600.00',
        discount: '10.00',
        total: '590.00',
        promoCode: 'PromoABC'
      },
      restaurant: {
        name: 'Food Mexican',
        type: 'Food Truck',
        phoneNumber: '+123 456 7890',
        location: '123 Dummy Street USA'
      }
    },
    {
      id: '12346',
      orderDate: '2024-03-15',
      orderTime: '02:30 PM',
      amount: '300.00',
      status: 'ready_to_pickup',
      items: [
        {
          id: '1',
          name: 'Enchiladas Supreme',
          image: '',
          price: '300.00',
          quantity: 1,
          total: '300.00'
        }
      ],
      summary: {
        subTotal: '300.00',
        discount: '0.00',
        total: '300.00'
      },
      restaurant: {
        name: 'Mexican Grill',
        type: 'Food Truck',
        phoneNumber: '+123 456 7890',
        location: '456 Dummy Street USA'
      }
    },
    {
      id: '12347',
      orderDate: '2024-03-14',
      orderTime: '01:15 PM',
      amount: '400.00',
      status: 'rejected',
      items: [
        {
          id: '1',
          name: 'Quesadilla Combo',
          image: '',
          price: '400.00',
          quantity: 1,
          total: '400.00'
        }
      ],
      summary: {
        subTotal: '400.00',
        discount: '0.00',
        total: '400.00'
      },
      restaurant: {
        name: 'Taco Express',
        type: 'Food Truck',
        phoneNumber: '+123 456 7890',
        location: '789 Dummy Street USA'
      }
    },
    {
      id: '12348',
      orderDate: '2024-03-14',
      orderTime: '03:45 PM',
      amount: '500.00',
      status: 'preparing',
      items: [
        {
          id: '1',
          name: 'Fajita Special',
          image: '',
          price: '250.00',
          quantity: 2,
          total: '500.00'
        }
      ],
      summary: {
        subTotal: '500.00',
        discount: '0.00',
        total: '500.00'
      },
      restaurant: {
        name: 'Mexican Corner',
        type: 'Food Truck',
        phoneNumber: '+123 456 7890',
        location: '321 Dummy Street USA'
      }
    },
    {
      id: '12349',
      orderDate: '2024-03-13',
      orderTime: '06:20 PM',
      amount: '450.00',
      status: 'completed',
      loyaltyPoints: 30,
      items: [
        {
          id: '1',
          name: 'Nachos Grande',
          image: '',
          price: '150.00',
          quantity: 3,
          total: '450.00'
        }
      ],
      summary: {
        subTotal: '450.00',
        discount: '0.00',
        total: '450.00'
      },
      restaurant: {
        name: 'Burrito King',
        type: 'Food Truck',
        phoneNumber: '+123 456 7890',
        location: '654 Dummy Street USA'
      }
    }
  ],
  pagination: {
    total: 5,
    per_page: 10,
    current_page: 1,
    total_pages: 1
  }
};
export const loyaltyProgramLogs = {
  data: [
    {
      id: '01',
      programType: 'Bronze',
      subscribedOn: '2024-03-15',
      expiresOn: '2024-04-15',
      amount: '20',
      status: 'Current'
    },
    {
      id: '02',
      programType: 'Silver',
      subscribedOn: '2024-02-15',
      expiresOn: '2024-03-15',
      amount: '30',
      status: 'Past'
    },
    {
      id: '03',
      programType: 'Gold',
      subscribedOn: '2024-01-15',
      expiresOn: '2024-02-15',
      amount: '10',
      status: 'Past'
    },
    {
      id: '04',
      programType: 'Bronze',
      subscribedOn: '2023-12-15',
      expiresOn: '2024-01-15',
      amount: '20',
      status: 'Past'
    },
    {
      id: '05',
      programType: 'Gold',
      subscribedOn: '2023-11-15',
      expiresOn: '2023-12-15',
      amount: '20',
      status: 'Past'
    },
    {
      id: '06',
      programType: 'Silver',
      subscribedOn: '2023-10-15',
      expiresOn: '2023-11-15',
      amount: '10',
      status: 'Past'
    },
    {
      id: '07',
      programType: 'Bronze',
      subscribedOn: '2023-09-15',
      expiresOn: '2023-10-15',
      amount: '20',
      status: 'Past'
    }
  ],
  pagination: {
    total: 7,
    per_page: 10,
    current_page: 1,
    total_pages: 1
  }
};
export const notifications = [
  {
    id: 1,
    user: {
      name: 'Emily Clark',
      'profile-image':
        'https://t3.ftcdn.net/jpg/06/92/98/26/360_F_692982616_sFOE56exqjylP20296OjiD83FQxewdDw.jpg',
    },
    action: 'liked your comment',
    notificationText: `John reported an issue: "Unable to create a new football discussion group."`,
    timestamp: '5 minutes ago',
    date: '08/19/2024',
    read: true,
  },
  {
    id: 2,
    user: {
      name: 'John Doe',
      'profile-image':
        'https://t3.ftcdn.net/jpg/06/92/98/26/360_F_692982616_sFOE56exqjylP20296OjiD83FQxewdDw.jpg',
    },
    action: 'shared your post',
    notificationText: `Alex raised a query: "Posted football tactics, but it doesn't show in the group."`,
    timestamp: '3 hours ago',
    date: '08/19/2024',
    read: false,
  },
  {
    id: 3,
    user: {
      name: 'Sophia Brown',
      'profile-image':
        'https://t3.ftcdn.net/jpg/06/92/98/26/360_F_692982616_sFOE56exqjylP20296OjiD83FQxewdDw.jpg',
    },
    action:
      'commented on your photo and this text is here just to make the notification very long',
    notificationText: `Chris submitted a complaint: "Messages not sending in the group chat."`,
    timestamp: '10 minutes ago',
    date: '08/19/2024',
    read: true,
  },
  {
    id: 4,
    user: {
      name: 'David Wilson',
      'profile-image':
        'https://t3.ftcdn.net/jpg/06/92/98/26/360_F_692982616_sFOE56exqjylP20296OjiD83FQxewdDw.jpg',
    },
    action: 'followed you',
    notificationText: `Andrew encountered a problem: "Trying to join a football analysis group but getting an error."`,
    timestamp: '1 day ago',
    date: '08/18/2024',
    read: false,
  },
  {
    id: 5,
    user: {
      name: 'Olivia Johnson',
      'profile-image':
        'https://t3.ftcdn.net/jpg/06/92/98/26/360_F_692982616_sFOE56exqjylP20296OjiD83FQxewdDw.jpg',
    },
    action: 'added your post to favorites',
    notificationText: `James flagged an issue: "Football post content gets flagged for no reason."`,
    timestamp: '30 minutes ago',
    date: '08/19/2024',
    read: true,
  },
];
export const remittanceData = {
  labels: ['Sales', 'Revenue', 'Orders', 'Vendors'],
  datasets: [
    {
      label: 'Remittance',
      data: [40, 30, 20, 10],
      backgroundColor: ['#1f4047', '#fdc770', '#B6C0C3', '#666'],
      borderWidth: 0,
    },
  ],
  options: {
    maintainAspectRatio: false,
    responsive: true,
    plugins: {
      legend: {
        position: 'left',
        labels: {
          padding: 0, // Increase padding between items
          boxWidth: 30, // Set width of the color box for each legend item
          boxHeight: 30, // Set width of the color box for each legend item
          font: {
            family: 'Plus Jakarta Sans',
            size: 14, // Adjust font size to further space items
            lineHeight: 1.5,
          },
        },
      },
    },
  },
};
export const cashBalanceData = {
  type: 'bar',
  labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'June', 'July'],
  datasets: [
    {
      label: 'Cashhh',
      data: [65, 59, 80, 81, 56, 55, 40],
      backgroundColor: ['#1f4047', '#fdc770'],
      borderWidth: 0,
      barThickness: 30,
    },
  ],
  options: {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
      title: {
        display: false,
      },
    },
    scales: {
      y: {
        ticks: {
          maxTicksLimit: 6,
          font: {
            family: 'Plus Jakarta Sans',
          },
        },
        beginAtZero: true,
      },
      x: {
        ticks: {
          font: {
            family: 'Plus Jakarta Sans',
          },
        },
      },
    },
  },
};
export const lineGraphOptions = {
  maintainAspectRatio: false,
  responsive: true,
  interaction: {
    mode: 'nearest', // Show the nearest point
    intersect: false, // Show point even if not exactly on it
  },
  plugins: {
    tooltip: {
      intersect: false,
    },
    legend: {
      display: false,
    },
    title: {
      display: false,
    },
  },
  scales: {
    y: {
      ticks: {
        maxTicksLimit: 6,

        font: {
          family: 'Plus Jakarta Sans',
          size: 14, // Adjust font size to further space items
          lineHeight: 1.5,
        },
      },
      title: {
        display: false,
      },
      beginAtZero: true,
    },
    x: {
      ticks: {
        font: {
          family: 'Plus Jakarta Sans',
          size: 14, // Adjust font size to further space items
          lineHeight: 1.5,
        },
      },
      title: {
        display: false,
      },
    },
  },
};
export const netIncomeRatioData = {
  labels: [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'June',
    'July',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ],
  datasets: [
    {
      data: [10, 17, 12, 14, 15, 18, 19, 23, 25, 20, 29, 32],
      borderRadius: 50,
      tension: 0.4,
      pointBorderColor: '#ccc',
      pointRadius: 0, // Hide points by default
      pointHoverRadius: 6, // Show points when hovering
      pointBorderWidth: 5,
      pointHoverBorderWidth: 5,
      pointBackgroundColor: '#fff',
      borderColor: '#ccc',
      borderWidth: 2,
      fill: {
        target: 'origin',
      },
      backgroundColor: 'rgba(0, 0, 0, 0.2)',
    },
  ],
};
// Admin
export const notificationsData = {
  status: true,
  message: 'admin notifications',
  detail: {
    notifications: {
      current_page: 1,
      data: [
        {
          id: '2fb2b0ba-4859-47c4-826c-1742a8ac39db',
          type: 'App\\Core\\Notifications\\PushNotification',
          notifiable_type: 'App\\Models\\Admin',
          notifiable_id: 1,
          data: {
            title: 'New Feedback',
            body: 'There are many variations of passages of Lorem Ipsum available. There are many variations of passages of Lorem Ipsum available.',
            route: {
              name: 'admin.feedbacks.show',
              params: {
                id: 77,
              },
            },
          },
          created_at: '2024-12-28T10:42:45.000000Z',
          updated_at: '2024-06-14T10:42:45.000000Z',
        },
        {
          id: '31d6a0f8-d820-4afd-a1c7-e64abaf8796a',
          type: 'App\\Core\\Notifications\\PushNotification',
          notifiable_type: 'App\\Models\\Admin',
          notifiable_id: 1,
          data: {
            title: 'New Feedback',
            body: 'There are many variations of passages of Lorem Ipsum available. There are many variations of passages of Lorem Ipsum available.',
            route: {
              name: 'admin.feedbacks.show',
              params: {
                id: 74,
              },
            },
          },
          read_at: null,
          created_at: '2024-06-06T12:03:40.000000Z',
          updated_at: '2024-06-06T12:03:40.000000Z',
        },
        {
          id: '3e380bad-85bf-411a-ab5a-ed3977bf179c',
          type: 'App\\Core\\Notifications\\PushNotification',
          notifiable_type: 'App\\Models\\Admin',
          notifiable_id: 1,
          data: {
            title: 'New Feedback',
            body: 'There are many variations of passages of Lorem Ipsum available. There are many variations of passages of Lorem Ipsum available.',
            route: {
              name: 'admin.feedbacks.show',
              params: {
                id: 71,
              },
            },
          },
          created_at: '2024-05-30T13:20:22.000000Z',
          updated_at: '2024-05-30T13:20:22.000000Z',
        },
        {
          id: '6169abb9-24cb-4f47-9bb4-74bc886dfa5a',
          type: 'App\\Core\\Notifications\\PushNotification',
          notifiable_type: 'App\\Models\\Admin',
          notifiable_id: 1,
          data: {
            title: 'New Feedback',
            body: 'There are many variations of passages of Lorem Ipsum available. There are many variations of passages of Lorem Ipsum available.',
            route: {
              name: 'admin.feedbacks.show',
              params: {
                id: 78,
              },
            },
          },
          read_at: '2024-06-14T10:42:45.000000Z',
          created_at: '2024-06-25T11:16:18.000000Z',
          updated_at: '2024-06-25T11:16:18.000000Z',
        },
        {
          id: '704674e3-84c6-4de4-878e-5f6a53a1c16a',
          type: 'App\\Core\\Notifications\\PushNotification',
          notifiable_type: 'App\\Models\\Admin',
          notifiable_id: 1,
          data: {
            title: 'New Feedback',
            body: 'There are many variations of passages of Lorem Ipsum available. There are many variations of passages of Lorem Ipsum available.',
            route: {
              name: 'admin.feedbacks.show',
              params: {
                id: 72,
              },
            },
          },
          read_at: null,
          created_at: '2024-05-30T13:21:05.000000Z',
          updated_at: '2024-05-30T13:21:05.000000Z',
        },
        {
          id: '7b4774e0-0326-4481-8a33-044c1c047810',
          type: 'App\\Core\\Notifications\\PushNotification',
          notifiable_type: 'App\\Models\\Admin',
          notifiable_id: 1,
          data: {
            title: 'New Feedback',
            body: 'There are many variations of passages of Lorem Ipsum available. There are many variations of passages of Lorem Ipsum available.',
            route: {
              name: 'admin.feedbacks.show',
              params: {
                id: 81,
              },
            },
          },
          read_at: null,
          created_at: '2024-06-25T11:17:25.000000Z',
          updated_at: '2024-06-25T11:17:25.000000Z',
        },
        {
          id: '91740da1-89df-407b-a2c0-042ed28a1468',
          type: 'App\\Core\\Notifications\\PushNotification',
          notifiable_type: 'App\\Models\\Admin',
          notifiable_id: 1,
          data: {
            title: 'New Feedback',
            body: 'There are many variations of passages of Lorem Ipsum available. There are many variations of passages of Lorem Ipsum available.',
            route: {
              name: 'admin.feedbacks.show',
              params: {
                id: 83,
              },
            },
          },
          read_at: null,
          created_at: '2024-06-26T11:22:54.000000Z',
          updated_at: '2024-06-26T11:22:54.000000Z',
        },
        {
          id: '9ff7d276-caa5-475d-845a-4d0359d0e91d',
          type: 'App\\Core\\Notifications\\PushNotification',
          notifiable_type: 'App\\Models\\Admin',
          notifiable_id: 1,
          data: {
            title: 'New Feedback',
            body: 'There are many variations of passages of Lorem Ipsum available. There are many variations of passages of Lorem Ipsum available.',
            route: {
              name: 'admin.feedbacks.show',
              params: {
                id: 69,
              },
            },
          },
          read_at: null,
          created_at: '2024-05-30T11:21:32.000000Z',
          updated_at: '2024-05-30T11:21:32.000000Z',
        },
      ],
      first_page_url:
        'http://localhost/food_app/admin-api/notifications?page=1',
      from: 1,
      last_page: 2,
      last_page_url: 'http://localhost/food_app/admin-api/notifications?page=2',
      links: [
        {
          url: null,
          label: '&laquo; Previous',
          active: false,
        },
        {
          url: 'http://localhost/food_app/admin-api/notifications?page=1',
          label: '1',
          active: true,
        },
        {
          url: 'http://localhost/food_app/admin-api/notifications?page=2',
          label: '2',
          active: false,
        },
        {
          url: 'http://localhost/food_app/admin-api/notifications?page=2',
          label: 'Next &raquo;',
          active: false,
        },
      ],
      next_page_url: 'http://localhost/food_app/admin-api/notifications?page=2',
      path: 'http://localhost/food_app/admin-api/notifications',
      per_page: 10,
      prev_page_url: null,
      to: 10,
      total: 14,
    },
    total_notifications: 0,
  },
};
export const userManagementData = [
  {
    id: 1,
    business_id: 12365,
    business_name: 'ABC Corp',
    contact_person: 'John Doe',
    user_id: 'user123',
    phone_no: '1265798687',
    email_address: 'abc@example.com',
    registration_date: '12/01/2024',
    status: 'active',
  },
  {
    id: 2,
    business_id: 18445,
    business_name: 'XYZ Ltd',
    contact_person: 'Jane Smith',
    user_id: 'user124',
    phone_no: '9876543210',
    email_address: 'xyz@example.com',
    registration_date: '15/02/2024',
    status: 'active',
  },
  {
    id: 3,
    business_id: 4856,
    business_name: 'Acme Co',
    contact_person: 'Robert Brown',
    user_id: 'user125',
    phone_no: '1122334455',
    email_address: 'acme@example.com',
    registration_date: '20/03/2024',
    status: 'active',
  },
  {
    id: 4,
    business_id: 58964,
    business_name: 'Global Tech',
    contact_person: 'Emily White',
    user_id: 'user126',
    phone_no: '9988776655',
    email_address: 'global@example.com',
    registration_date: '25/04/2024',
    status: 'inactive',
  },
  {
    id: 5,
    business_id: 5687,
    business_name: 'Innovatech',
    contact_person: 'Chris Green',
    user_id: 'user127',
    phone_no: '7766554433',
    email_address: 'innovatech@example.com',
    registration_date: '30/05/2024',
    status: 'inactive',
  },
  {
    id: 6,
    business_id: 5496,
    business_name: 'TechWave',
    contact_person: 'Alex Johnson',
    user_id: 'user128',
    phone_no: '6655443322',
    email_address: 'techwave@example.com',
    registration_date: '05/06/2024',
    status: 'active',
  },
  {
    id: 7,
    business_id: 2314,
    business_name: 'NextGen Solutions',
    contact_person: 'Samantha Lee',
    user_id: 'user129',
    phone_no: '5544332211',
    email_address: 'nextgen@example.com',
    registration_date: '10/07/2024',
    status: 'active',
  },
];

export const restaurantsNearMeData = {
  status: true,
  message: 'Restaurants Near Me',
  detail: [
    {
      id: 1,
      title: 'Angus Cafe',
      rating: 4.5,
      reviews: [],
      description: 'Experience fine dining with our signature dishes and elegant atmosphere. Perfect for special occasions.',
      distance: '1.5',
      time: '15-20 mins',
      img: ''
    },
    {
      id: 2,
      title: 'Hot Dog Truck',
      rating: 4.3,
      reviews: [],
      description: 'Authentic Indian cuisine with a modern twist. Known for our aromatic curries and fresh bread.',
      distance: '2.1',
      time: '20-25 mins',
      img: ''
    },
    {
      id: 3,
      title: 'Steak House',
      rating: 4.7,
      reviews: [],
      description: 'Gourmet burgers made with premium ingredients. Try our signature BBQ bacon burger!',
      distance: '0.8',
      time: '10-15 mins',
      img: ''
    },
    {
      id: 4,
      title: 'Caribbean Food Truck',
      rating: 4.6,
      reviews: [],
      description: 'Fresh and authentic Japanese sushi and sashimi. Expert chefs with premium ingredients.',
      distance: '1.2',
      time: '15-20 mins',
      img: ''
    },
    {
      id: 5,
      title: 'Yumbii',
      rating: 4.4,
      reviews: [],
      description: 'Wood-fired pizzas with traditional Italian recipes. Fresh ingredients and homemade sauce.',
      distance: '1.7',
      time: '20-25 mins',
      img: ''
    },
    {
      id: 6,
      title: 'Sub Street',
      rating: 4.2,
      reviews: [],
      description: 'Authentic Mediterranean cuisine featuring fresh seafood, kebabs, and mezze platters.',
      distance: '2.5',
      time: '25-30 mins',
      img: ''
    },
    {
      id: 7,
      title: 'Liberty',
      rating: 4.5,
      reviews: [],
      description: 'Authentic Mexican street food with a modern twist. Famous for our handmade tortillas.',
      distance: '1.3',
      time: '15-20 mins',
      img: ''
    },
    {
      id: 8,
      title: 'Spicy Food Truck',
      rating: 4.4,
      reviews: [],
      description: 'Asian fusion noodles and stir-fries. Specializing in hand-pulled noodles and dumplings.',
      distance: '1.9',
      time: '20-25 mins',
      img: ''
    }
  ]
};

export const productsData = {
  status: true,
  message: 'Products',
  data: [
    {
      id: 1,
      title: 'Angus Cafe',
      rating: 4.5,
      totalRatings: 100,
      reviews: {
        averageRating: 4.5,
        totalReviews: 200,
        ratingCounts: {
          5: 100,
          4: 25,
          3: 25,
          2: 25,
          1: 25
        },
        reviewList: [
          {
            id: 1,
            userName: "Tom Albert",
            rating: 4.5,
            date: "May, 22 2025",
            comment: "Lorem Ipsum Dolor Sit Amet, Consectetur Adipiscing Elit. Aenean Euismod Bibendum Laoreet. Proin Gravida Dolor Sit Amet Lacus Elit. Accumsan Et Viverra Justo Commodo. Proin Sodales Pulvinar Tempor. Lorem Ipsum Dolor Sit Amet, Consectetur Adipiscing Elit. Lacus Aenean Euismod Bibendum Laoreet. Proin Gravida Dolor Sit Amet Lacus Accumsan"
          },
          {
            id: 2,
            userName: "Sarah Johnson",
            rating: 5,
            date: "May, 20 2025",
            comment: "Exceptional dining experience! The steaks were cooked to perfection and the service was impeccable."
          },
          {
            id: 3,
            userName: "Mike Chen",
            rating: 4,
            date: "May, 18 2025",
            comment: "Great food and atmosphere. Slightly pricey but worth it for special occasions."
          },
          {
            id: 4,
            userName: "Emily Davis",
            rating: 3,
            date: "May, 15 2025",
            comment: "Decent food but had to wait a bit too long. Service could be improved."
          }
        ]
      },
      price: 10,
      description: 'Experience fine dining with our signature dishes and elegant atmosphere. Perfect for special occasions.',
      distance: '1.5',
      time: '15-20 mins',
      img: '',
    },
    {
      id: 2,
      title: 'Hot Dog Truck',
      rating: 4.5,
      totalRatings: 100,
      reviews: {
        averageRating: 4.5,
        totalReviews: 200,
        ratingCounts: {
          5: 100,
          4: 25,
          3: 25,
          2: 25,
          1: 25
        },
        reviewList: [
          {
            id: 1,
            userName: "Tom Albert",
            rating: 4.5,
            date: "May, 22 2025",
            comment: "Lorem Ipsum Dolor Sit Amet, Consectetur Adipiscing Elit. Aenean Euismod Bibendum Laoreet. Proin Gravida Dolor Sit Amet Lacus Elit. Accumsan Et Viverra Justo Commodo. Proin Sodales Pulvinar Tempor. Lorem Ipsum Dolor Sit Amet, Consectetur Adipiscing Elit. Lacus Aenean Euismod Bibendum Laoreet. Proin Gravida Dolor Sit Amet Lacus Accumsan"
          },
          {
            id: 2,
            userName: "Sarah Johnson",
            rating: 5,
            date: "May, 20 2025",
            comment: "Exceptional dining experience! The steaks were cooked to perfection and the service was impeccable."
          },
          {
            id: 3,
            userName: "Mike Chen",
            rating: 4,
            date: "May, 18 2025",
            comment: "Great food and atmosphere. Slightly pricey but worth it for special occasions."
          },
          {
            id: 4,
            userName: "Emily Davis",
            rating: 3,
            date: "May, 15 2025",
            comment: "Decent food but had to wait a bit too long. Service could be improved."
          }
        ]
      },
      price: 10,
      description: 'Authentic Indian cuisine with a modern twist. Known for our aromatic curries and fresh bread.',
      distance: '2.1',
      time: '20-25 mins',
      img: ''
    },
    {
      id: 3,
      title: 'Steak House',
      rating: 4.5,
      totalRatings: 100,
      reviews: {
        averageRating: 4.5,
        totalReviews: 200,
        ratingCounts: {
          5: 100,
          4: 25,
          3: 25,
          2: 25,
          1: 25
        },
        reviewList: [
          {
            id: 1,
            userName: "Tom Albert",
            rating: 4.5,
            date: "May, 22 2025",
            comment: "Lorem Ipsum Dolor Sit Amet, Consectetur Adipiscing Elit. Aenean Euismod Bibendum Laoreet. Proin Gravida Dolor Sit Amet Lacus Elit. Accumsan Et Viverra Justo Commodo. Proin Sodales Pulvinar Tempor. Lorem Ipsum Dolor Sit Amet, Consectetur Adipiscing Elit. Lacus Aenean Euismod Bibendum Laoreet. Proin Gravida Dolor Sit Amet Lacus Accumsan"
          },
          {
            id: 2,
            userName: "Sarah Johnson",
            rating: 5,
            date: "May, 20 2025",
            comment: "Exceptional dining experience! The steaks were cooked to perfection and the service was impeccable."
          },
          {
            id: 3,
            userName: "Mike Chen",
            rating: 4,
            date: "May, 18 2025",
            comment: "Great food and atmosphere. Slightly pricey but worth it for special occasions."
          },
          {
            id: 4,
            userName: "Emily Davis",
            rating: 3,
            date: "May, 15 2025",
            comment: "Decent food but had to wait a bit too long. Service could be improved."
          }
        ]
      },
      price: 10,
      description: 'Gourmet burgers made with premium ingredients. Try our signature BBQ bacon burger!',
      distance: '0.8',
      time: '10-15 mins',
      img: ''
    },
    {
      id: 4,
      title: 'Caribbean Food Truck',
      rating: 4.5,
      totalRatings: 100,
      reviews: {
        averageRating: 4.5,
        totalReviews: 200,
        ratingCounts: {
          5: 100,
          4: 25,
          3: 25,
          2: 25,
          1: 25
        },
        reviewList: [
          {
            id: 1,
            userName: "Tom Albert",
            rating: 4.5,
            date: "May, 22 2025",
            comment: "Lorem Ipsum Dolor Sit Amet, Consectetur Adipiscing Elit. Aenean Euismod Bibendum Laoreet. Proin Gravida Dolor Sit Amet Lacus Elit. Accumsan Et Viverra Justo Commodo. Proin Sodales Pulvinar Tempor. Lorem Ipsum Dolor Sit Amet, Consectetur Adipiscing Elit. Lacus Aenean Euismod Bibendum Laoreet. Proin Gravida Dolor Sit Amet Lacus Accumsan"
          },
          {
            id: 2,
            userName: "Sarah Johnson",
            rating: 5,
            date: "May, 20 2025",
            comment: "Exceptional dining experience! The steaks were cooked to perfection and the service was impeccable."
          },
          {
            id: 3,
            userName: "Mike Chen",
            rating: 4,
            date: "May, 18 2025",
            comment: "Great food and atmosphere. Slightly pricey but worth it for special occasions."
          },
          {
            id: 4,
            userName: "Emily Davis",
            rating: 3,
            date: "May, 15 2025",
            comment: "Decent food but had to wait a bit too long. Service could be improved."
          }
        ]
      },
      price: 10,
      description: 'Fresh and authentic Japanese sushi and sashimi. Expert chefs with premium ingredients.',
      distance: '1.2',
      time: '15-20 mins',
      img: ''
    },
    {
      id: 5,
      title: 'Yumbii',
      rating: 4.5,
      totalRatings: 100,
      reviews: {
        averageRating: 4.5,
        totalReviews: 200,
        ratingCounts: {
          5: 100,
          4: 25,
          3: 25,
          2: 25,
          1: 25
        },
        reviewList: [
          {
            id: 1,
            userName: "Tom Albert",
            rating: 4.5,
            date: "May, 22 2025",
            comment: "Lorem Ipsum Dolor Sit Amet, Consectetur Adipiscing Elit. Aenean Euismod Bibendum Laoreet. Proin Gravida Dolor Sit Amet Lacus Elit. Accumsan Et Viverra Justo Commodo. Proin Sodales Pulvinar Tempor. Lorem Ipsum Dolor Sit Amet, Consectetur Adipiscing Elit. Lacus Aenean Euismod Bibendum Laoreet. Proin Gravida Dolor Sit Amet Lacus Accumsan"
          },
          {
            id: 2,
            userName: "Sarah Johnson",
            rating: 5,
            date: "May, 20 2025",
            comment: "Exceptional dining experience! The steaks were cooked to perfection and the service was impeccable."
          },
          {
            id: 3,
            userName: "Mike Chen",
            rating: 4,
            date: "May, 18 2025",
            comment: "Great food and atmosphere. Slightly pricey but worth it for special occasions."
          },
          {
            id: 4,
            userName: "Emily Davis",
            rating: 3,
            date: "May, 15 2025",
            comment: "Decent food but had to wait a bit too long. Service could be improved."
          }
        ]
      },
      price: 10,
      description: 'Wood-fired pizzas with traditional Italian recipes. Fresh ingredients and homemade sauce.',
      distance: '1.7',
      time: '20-25 mins',
      img: ''
    },
    {
      id: 6,
      title: 'Sub Street',
      rating: 4.5,
      totalRatings: 100,
      reviews: {
        averageRating: 4.5,
        totalReviews: 200,
        ratingCounts: {
          5: 100,
          4: 25,
          3: 25,
          2: 25,
          1: 25
        },
        reviewList: [
          {
            id: 1,
            userName: "Tom Albert",
            rating: 4.5,
            date: "May, 22 2025",
            comment: "Lorem Ipsum Dolor Sit Amet, Consectetur Adipiscing Elit. Aenean Euismod Bibendum Laoreet. Proin Gravida Dolor Sit Amet Lacus Elit. Accumsan Et Viverra Justo Commodo. Proin Sodales Pulvinar Tempor. Lorem Ipsum Dolor Sit Amet, Consectetur Adipiscing Elit. Lacus Aenean Euismod Bibendum Laoreet. Proin Gravida Dolor Sit Amet Lacus Accumsan"
          },
          {
            id: 2,
            userName: "Sarah Johnson",
            rating: 5,
            date: "May, 20 2025",
            comment: "Exceptional dining experience! The steaks were cooked to perfection and the service was impeccable."
          },
          {
            id: 3,
            userName: "Mike Chen",
            rating: 4,
            date: "May, 18 2025",
            comment: "Great food and atmosphere. Slightly pricey but worth it for special occasions."
          },
          {
            id: 4,
            userName: "Emily Davis",
            rating: 3,
            date: "May, 15 2025",
            comment: "Decent food but had to wait a bit too long. Service could be improved."
          }
        ]
      },
      price: 10,
      description: 'Authentic Mediterranean cuisine featuring fresh seafood, kebabs, and mezze platters.',
      distance: '2.5',
      time: '25-30 mins',
      img: ''
    },
    {
      id: 7,
      title: 'Liberty',
      rating: 4.5,
      totalRatings: 100,
      reviews: {
        averageRating: 4.5,
        totalReviews: 200,
        ratingCounts: {
          5: 100,
          4: 25,
          3: 25,
          2: 25,
          1: 25
        },
        reviewList: [
          {
            id: 1,
            userName: "Tom Albert",
            rating: 4.5,
            date: "May, 22 2025",
            comment: "Lorem Ipsum Dolor Sit Amet, Consectetur Adipiscing Elit. Aenean Euismod Bibendum Laoreet. Proin Gravida Dolor Sit Amet Lacus Elit. Accumsan Et Viverra Justo Commodo. Proin Sodales Pulvinar Tempor. Lorem Ipsum Dolor Sit Amet, Consectetur Adipiscing Elit. Lacus Aenean Euismod Bibendum Laoreet. Proin Gravida Dolor Sit Amet Lacus Accumsan"
          },
          {
            id: 2,
            userName: "Sarah Johnson",
            rating: 5,
            date: "May, 20 2025",
            comment: "Exceptional dining experience! The steaks were cooked to perfection and the service was impeccable."
          },
          {
            id: 3,
            userName: "Mike Chen",
            rating: 4,
            date: "May, 18 2025",
            comment: "Great food and atmosphere. Slightly pricey but worth it for special occasions."
          },
          {
            id: 4,
            userName: "Emily Davis",
            rating: 3,
            date: "May, 15 2025",
            comment: "Decent food but had to wait a bit too long. Service could be improved."
          }
        ]
      },
      price: 10,
      description: 'Authentic Mexican street food with a modern twist. Famous for our handmade tortillas.',
      distance: '1.3',
      time: '15-20 mins',
      img: ''
    },
    {
      id: 8,
      title: 'Spicy Food Truck',
      rating: 4.5,
      totalRatings: 100,
      reviews: {
        averageRating: 4.5,
        totalReviews: 200,
        ratingCounts: {
          5: 100,
          4: 25,
          3: 25,
          2: 25,
          1: 25
        },
        reviewList: [
          {
            id: 1,
            userName: "Tom Albert",
            rating: 4.5,
            date: "May, 22 2025",
            comment: "Lorem Ipsum Dolor Sit Amet, Consectetur Adipiscing Elit. Aenean Euismod Bibendum Laoreet. Proin Gravida Dolor Sit Amet Lacus Elit. Accumsan Et Viverra Justo Commodo. Proin Sodales Pulvinar Tempor. Lorem Ipsum Dolor Sit Amet, Consectetur Adipiscing Elit. Lacus Aenean Euismod Bibendum Laoreet. Proin Gravida Dolor Sit Amet Lacus Accumsan"
          },
          {
            id: 2,
            userName: "Sarah Johnson",
            rating: 5,
            date: "May, 20 2025",
            comment: "Exceptional dining experience! The steaks were cooked to perfection and the service was impeccable."
          },
          {
            id: 3,
            userName: "Mike Chen",
            rating: 4,
            date: "May, 18 2025",
            comment: "Great food and atmosphere. Slightly pricey but worth it for special occasions."
          },
          {
            id: 4,
            userName: "Emily Davis",
            rating: 3,
            date: "May, 15 2025",
            comment: "Decent food but had to wait a bit too long. Service could be improved."
          }
        ]
      },
      price: 10,
      description: 'Asian fusion noodles and stir-fries. Specializing in hand-pulled noodles and dumplings.',
      distance: '1.9',
      time: '20-25 mins',
      img: ''
    }
  ]
};

